var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_2625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.8418H42V34.8418H0V4.8418Z",
    fill: "#64A6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 2.84155H4.00012V30.8417H16.9999L19.0001 32.8416L21 34.8418V6.84167L16.9999 2.84155Z",
    fill: "#C1CAD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 2.84155L21 6.84167V34.8418L25.0001 30.8417H37.9999V2.84155H25.0001Z",
    fill: "#F8FAFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0001 25.842V37.842C45.9968 38.9451 45.1033 39.8386 43.9999 39.8419H40.0001L34.9999 44.8418V39.8419H30C28.897 39.8386 28.0034 38.9451 28.0001 37.842V25.842C28.0034 24.7386 28.897 23.8451 30 23.8418H43.9999C45.1033 23.8451 45.9968 24.7386 46.0001 25.842Z",
    fill: "#F4D362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 22.8418H12V15.8417H10.0001V13.8418H13.0001C13.5524 13.8418 13.9999 14.2893 13.9999 14.8416V22.8418Z",
    fill: "#7C8691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 21.8418H16.0001V23.8417H10.0001V21.8418Z",
    fill: "#7C8691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.8418H13.9999V11.8417H12V9.8418Z",
    fill: "#7C8691"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9999 33.8417H36V31.8419C36 31.2896 36.4479 30.8417 37.0001 30.8417C37.5524 30.8417 37.9999 30.3939 37.9999 29.8416C37.9999 29.2894 37.5524 28.8419 37.0001 28.8419C36.4479 28.8419 36 29.2894 36 29.8416H34.0001C34.0001 28.3163 35.1456 27.0339 36.6614 26.8614C38.1771 26.6893 39.5808 27.6821 39.9232 29.1685C40.266 30.6553 39.4384 32.1623 37.9999 32.6706V33.8417Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 34.8418H37.9999V36.8417H36V34.8418Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 6.8418H34.9999V8.84167H25.9999V6.8418Z",
    fill: "#CCD6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10.8418H34.9999V12.8417H24V10.8418Z",
    fill: "#CCD6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 14.8418H34.9999V16.842H24V14.8418Z",
    fill: "#CCD6E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 18.8418H34.9999V20.8417H24V18.8418Z",
    fill: "#CCD6E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_2625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(0 0.810547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.33f5bdcf82bc03cfb9774e67458aa6f4.svg";
export { ForwardRef as ReactComponent };